import { render, staticRenderFns } from "./CollectionEditModal.vue?vue&type=template&id=dda7e20e"
import script from "./CollectionEditModal.vue?vue&type=script&lang=ts"
export * from "./CollectionEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports